import PropTypes from "prop-types";
import React, { useState } from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../slices/thunks";
import { useParams } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// import images
// import profile from "../../assets/images/bg.png";
import logoLight from "../../assets/images/logo-light.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";
import AuthenticationsServices from "../../Services/AuthenticationService/AuthenticationsServices";
import toast from "react-hot-toast";

const ChangePassword = (prop) => {
  const [oldPasswordShow, setOldPasswordShow] = useState(false);
  const [newPasswordShow, setNewPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);

  const { user } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const idValue =userName || 0;
  // console.log(idValue);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      //emailAddress: Yup.string().required("Please Enter Your Email"),
      oldPassword: Yup.string().required("Please Enter Your Password"),
      newPassword: Yup.string().required("Please Enter Your Password"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
        .required("Please confirm your password"),
    }),
    onSubmit: async (values) => {
      console.log(
        "🚀 ~ file: ChangePassword.js:53 ~ onSubmit: ~ values:",
        values
      );
      try {
        const { oldPassword, newPassword, confirmPassword } = values;

        // Make the API call using the AuthenticationsServices object
        await AuthenticationsServices.changePassword(values);
        toast.success("Password has been changed successfully!", {
          autoClose: 3000,
        });

        setTimeout(() => {
          handleLogout();
        }, 1000);

        navigate("/dashboard");

        // console.log("Password change response:", response);
        // Handle success scenario (e.g., show success message to the user)
      } catch (error) {
        console.error("Password change error:", error);
        toast.error("Something went wrong!");
        // Handle error scenario (e.g., show an error message to the user)
      }
    },
  });

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <h4 className="text-muted text-center mt-3">Change Password</h4>
                <CardBody className="p-2">
                  <div className="p-2">
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">Old Password</Label>
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <Input
                            name="oldPassword"
                            className="form-control"
                            placeholder="Enter old Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.oldPassword || ""}
                            type={oldPasswordShow ? "text" : "password"}
                            invalid={
                              validation.touched.oldPassword &&
                              validation.errors.oldPassword
                                ? true
                                : false
                            }
                          />
                          {validation.touched.oldPassword &&
                          validation.errors.oldPassword ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.oldPassword}</div>
                            </FormFeedback>
                          ) : null}
                          <button
                            className="btn btn-link position-absolute  end-0 top-0 text-decoration-none text-muted"
                            type="button"
                            id="password-addon"
                            onClick={() => setOldPasswordShow(!oldPasswordShow)}
                          >
                            <i className="ri-eye-fill align-middle"></i>
                          </button>
                        </div>
                      </div>
                      <div className="mb-4">
                        <Label className="form-label">New Password</Label>
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <Input
                            name="newPassword"
                            value={validation.values.newPassword || ""}
                            type={newPasswordShow ? "text" : "password"}
                            className="form-control"
                            placeholder="Enter new  password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.newPassword &&
                              validation.errors.newPassword
                                ? true
                                : false
                            }
                          />
                          {validation.touched.newPassword &&
                          validation.errors.newPassword ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.newPassword}</div>
                            </FormFeedback>
                          ) : null}
                          <button
                            className="btn btn-link position-absolute  end-0 top-0 text-decoration-none text-muted"
                            type="button"
                            id="password-addon"
                            onClick={() => setNewPasswordShow(!newPasswordShow)}
                          >
                            <i className="ri-eye-fill align-middle"></i>
                          </button>
                        </div>
                      </div>

                      <div className="mb-4">
                        <Label className="form-label" htmlFor="password-input">
                          Confirm Password
                        </Label>
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <Input
                            name="confirmPassword"
                            className="form-control"
                            placeholder="Confirm new password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.confirmPassword || ""}
                            type={confirmPasswordShow ? "text" : "password"}
                            invalid={
                              validation.touched.confirmPassword &&
                              validation.errors.confirmPassword
                                ? true
                                : false
                            }
                          />
                          {validation.touched.confirmPassword &&
                          validation.errors.confirmPassword ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.confirmPassword}</div>
                            </FormFeedback>
                          ) : null}
                          <button
                            className="btn btn-link position-absolute  end-0 top-0 text-decoration-none text-muted"
                            type="button"
                            id="password-addon"
                            onClick={() =>
                              setConfirmPasswordShow(!confirmPasswordShow)
                            }
                          >
                            <i className="ri-eye-fill align-middle"></i>
                          </button>
                        </div>
                      </div>

                      <div className="text-center mt-4">
                        <button className="btn btn-success w-100" type="submit">
                          Reset Password
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* </Card> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ChangePassword;
